    document.querySelectorAll(".top_bar .init").length > 0 &&
        document.querySelectorAll(".top_bar .init").forEach((a) => {
            a.addEventListener("click", function (c) {
                var b = a.parentElement.querySelector(".itg_Your-country  .list-unstyled");
                b.classList.contains("active") ? b.classList.remove("active") : b.classList.add("active");
            });
        }),

$(document).ready(function () {
    console.log("Document ready ✅");

    $(document).on("click", ".copy-btn", function () {
        console.log("Copy button clicked 🔥");

        let $box = $(this).closest(".copy-box");
        let text = $box.find(".copy-text").text().trim();

        console.log("Text:", text);

        navigator.clipboard.writeText(text).then(() => {
            console.log("Copied");

            let $btn = $(this);
            $btn.find(".copied-text").text("Copied").addClass("copied");
            $btn.find(".copied-icon").hide();
            
            setTimeout(() => {
              $btn.find(".copied-text").text("Copy").removeClass("copied");
              $btn.find(".copied-icon").show();
            }, 1500);

        }).catch(err => {
            console.log("Copy failed ❌", err);
        });
    });
});
      
 
 $('body').on('click','.prev-next-button--next',function(){ 
 $('button.relative[aria-current="true"]').next().trigger('click'); 
    $('.prev-next-button--prev').removeAttr('disabled');
  });
$('body').on('click','.prev-next-button--prev',function(){ 
$('button.relative[aria-current="true"]').prev().trigger('click'); 
}); 
function changeCustomDate(){
  
   var message = "THIS ITEM WILL BE SHIPPED ON 15<sup>th</sup> NOVEMBER " ;
       $('.preorder-description').html(message);     
      $('.preorder-description').attr("style","display: block !important");  
}
var handleDates = setInterval(changeDate,1500);

//// code to add is-disabled class on size variant on load starts////
$(document).ready(function (e) {
 let low_threshold_jtpl=$(".product-info__block-item.afterpay-selector-jtpl #low_threshold_jtpl").val();
  let middle_threshold_jtpl=$(".product-info__block-item.afterpay-selector-jtpl #middle_threshold_jtpl").val();
  console.log("low_threshold_jtpl----->load--",low_threshold_jtpl);
  console.log("middle_threshold_jtpl----->load--",middle_threshold_jtpl)
   let isGiftCard=$(".product").find("#handle").hasClass("gift-card");
   let isTraining=$(".product").find("#handle").hasClass("training");
   let isFighter=$(".product").find("#handle").hasClass("fighter");
  if ($("input#handle").length ) {
    let handle=$("#handle").val();
    $.ajax({
      type:"GET",
      url:`/products/${handle}.js`,
      dataType:'json',
      success:(data)=>{
        console.log(data);
        let color=$('input[name="option2"]:checked').val()
        // console.log("Color:::::".color);
        let product_tags=data.tags;
        let variants=data.variants.filter((val)=>val.option2==color)
        $(".block-swatch").removeClass("is-disabled");
        console.log("Variants----->",variants);
        
         variants.forEach((item) => {
       if (!item.available) {
        let size=item.option1
        // console.log("Size disabled----->",size);
        
        $(`.block-swatch[data-option-value='${size}']`).addClass("is-disabled")
      }
    });
      let inventory_quantity=$("input#handle").attr("data-inventory");
  let inventory_policy=$("input#handle").attr("data-preoder");
  console.log("Inventoy======",inventory_quantity);
  console.log("Policy=====",inventory_policy);
  if (inventory_policy=='continue') {
    inventory_policy="true"
  }
  else{
    inventory_policy="false"
  }
   let inventoryStatusHtml=document.querySelector(".afterpay-selector-jtpl").outerHTML
  console.log("inventoryStatusHtml------>",inventoryStatusHtml);
    let buy_buttonsTstt= $(".product-info__block-item[data-block-type='buy-buttons']").prepend(inventoryStatusHtml)
   console.log('buy-buttonsTstt===>',buy_buttonsTstt);

  // if ($(".product-info__block-item[data-block-type='quantity-selector']").length) {
  //   $(".product-info__block-item[data-block-type='quantity-selector']").append(inventoryStatusHtml)
  // }
  // else{
  //  let buy_buttonsTstt= $(".product-info__block-item[data-block-type='buy-buttons']").prepend(inventoryStatusHtml)
  //  console.log('buy-buttonsTstt===>',buy_buttonsTstt);
   
  // }
  if (!isGiftCard && !isFighter && !isTraining) {
      manageInventoryStatus(inventory_quantity,inventory_policy,product_tags);
  }

      },
      error:(err)=>{
        console.log(err);
        
      }
    });
  }
});
//// code to add is-disabled class on size variant on load starts////
function onColorChange(data) {
  let product = data.product;
  let selected = data.variant;
  let color = data.variant.option2;
  let variants = product.variants.filter((val) => val.option2 == color);
  console.log("Variants---->", variants);

  // Enable all size swatches and inputs first
  $(".block-swatch").removeClass("is-disabled").each(function () {
    $(this).find("input[type='radio']").prop("disabled", false);
  });

  // Disable swatches & inputs for unavailable variants
  variants.forEach((item) => {
    if (!item.available) {
      let size = item.option1;
      console.log("Size disabled----->", size);
      const $swatch = $(`.block-swatch[data-option-value='${size}']`);
      $swatch.addClass("is-disabled");
      $swatch.find("input[type='radio']").prop("disabled", true);
    }
  });
}


function manageInventoryStatus(inventory_quantity,inventory_policy,product_tags) {
  let low_threshold_jtpl=$(".product-info__block-item.afterpay-selector-jtpl input#low_threshold_jtpl").val();
  let middle_threshold_jtpl=$(".product-info__block-item.afterpay-selector-jtpl input#middle_threshold_jtpl").val();
  low_threshold_jtpl=parseInt(low_threshold_jtpl);
   middle_threshold_jtpl=parseInt(middle_threshold_jtpl);
   
  console.log("low_threshold_jtpl----->",low_threshold_jtpl);
  console.log("middle_threshold_jtpl----->",middle_threshold_jtpl)
  
  let message="",status="";
    if (inventory_quantity <= 0 && inventory_policy == "true") {
      message = ''; // for text Pre-order
      status = 'warning';
    } else if (inventory_quantity >0 && inventory_quantity <= low_threshold_jtpl) {
      message = `Only ${inventory_quantity} left in stock - order soon`;
      status = 'error';
    } else if ( inventory_quantity >low_threshold_jtpl && inventory_quantity <= middle_threshold_jtpl) {
      message = 'Low stock - order soon';
      status = 'warning';
    }else if(inventory_quantity <= 0 && inventory_policy == "false"){
      if(product_tags.includes("blossom-out-of-stock") || product_tags.includes("out-of-stock") ){
        message = 'Out of stock';
        status = 'error';
      }
      else{
        message = 'Sold Out';
        status = 'error';
      }

    } 
    else {
      if (inventory_quantity <=0) {
        if(product_tags.includes("blossom-out-of-stock") || product_tags.includes("out-of-stock") ){
        message = 'Out of stock';
        status = 'error';
      }
      else{
        message = 'Sold Out';
        status = 'error';
      }
      }
      else{
        message = 'In stock';
        status = 'success';
      }

    }
    console.log("inventory_quantity----->",inventory_quantity);
    console.log("message---->",message);
    console.log("status------>",$("span#inventory_status_message_jtpl"));
    $("span#inventory_status_message_jtpl").text(message);
    $("span#inventory_status_message_jtpl").removeAttr('data-status');
    $("span#inventory_status_message_jtpl").attr('data-status',status);
}

document.addEventListener("variant:change", function (event) {
  var variant = event.detail.variant;
  onColorChange(event.detail);
  var product_tags = event.detail.product.tags;
  console.log("Variant change ------>", event);
 let isGiftCard=$(".product").find("#handle").hasClass("gift-card")
  let isTraining=$(".product").find("#handle").hasClass("training");
  let isFighter=$(".product").find("#handle").hasClass("fighter");
 console.log("isGiftCard------>",isGiftCard);
 
  if (!variant) return;

  var addToCartBtn = $(".button-cart-jtpl");
  console.log(addToCartBtn);

  var inventory_quantity = parseInt(
    $(".custom_main_variant option[value='" + variant.id + "']").attr("data-inv-qty")
  );
  $(".product-info__block-item .quantity-selector .quantity-selector__input").attr(
    "data-max",
    inventory_quantity
  );
  var inventory_policy = $(".custom_main_variant option[value='" + variant.id + "']").attr(
    "data-preOrder"
  );

  var isPreorder, isSoldOut;
  if (!isGiftCard && !isFighter && !isTraining) {
    manageInventoryStatus(inventory_quantity,inventory_policy,product_tags)
  }
  
///
// let message="",status="";
//     if (inventory_quantity <= 0 && inventory_policy == "true") {
//       message = ''; // for text Pre-order
//       status = 'warning';
//     } else if (inventory_quantity >= 1 && inventory_quantity <= 3) {
//       message = `Only ${inventory_quantity} left in stock - order soon`;
//       status = 'error';
//     } else if ( inventory_quantity >3 && inventory_quantity <= 15) {
//       message = 'Low stock - order soon';
//       status = 'warning';
//     }else if(inventory_quantity <= 0 && inventory_policy == "false"){
//       if(product_tags.includes("blossom-out-of-stock") || product_tags.includes("out-of-stock") ){
//         message = 'Out of stock';
//         status = 'error';
//       }
//       else{
//         message = 'Sold Out';
//         status = 'error';
//       }

//     } 
//     else {
//       message = 'In stock';
//       status = 'success';
//     }
//     console.log("inventory_quantity----->",inventory_quantity);
//     console.log("message---->",message);
//     console.log("status------>",$("span#inventory_status_message_jtpl"));
//     $("span#inventory_status_message_jtpl").text(message);
//     $("span#inventory_status_message_jtpl").removeAttr('data-status');
//     $("span#inventory_status_message_jtpl").attr('data-status',status);
    
    
//
  if (inventory_quantity < 1 && inventory_policy == "true") {
    isPreorder = "true";
    isSoldOut = "false";
  } else if (inventory_quantity <= 0 && inventory_policy == "false") {
    isPreorder = "false";
    isSoldOut = "true";
  } else {
    isPreorder = "false";
    isSoldOut = "false";
  }
  console.log(variant.id + "====" + inventory_quantity + "====" + inventory_policy + "===" + isPreorder);

   if (isPreorder == "true" && !isGiftCard) {    
    $('.button-cart-jtpl').text("Pre Order Now");
     var form = $(".pre-text-jtpl").attr("form");
     if($(".pre-text-jtpl .pn_note-jtpl").length > 0){
        $(".pn_note-jtpl").val("Pre-order Item");
     }else{
       $(".pre-text-jtpl").append('<input type="hidden" form="'+form+'" name="properties[PN-Note]" value="Pre-order Item" class="pn_note-jtpl"/> ');
     }
     //console.log("heree--"+$(".pre-text-jtpl .preorder-description").length+"===="+$(".pre-text-jtpl .pn_note-jtpl").length)
     if($(".pre-text-jtpl .preorder-description").length > 0){
        $(".preorder-description").attr("style","display:block !important");
     }else{
       $(".pre-text-jtpl ").append(' <p class="preorder-description">THIS ITEM WILL BE SHIPPED ON 15<sup>th</sup> NOVEMBER</p> ');
     }
      handleDates = setInterval(changeDate,900);
     $(".shopify-payment-button").attr("style","display:none !important");
  }else if(isSoldOut == "true" && !isGiftCard) {   
      if(product_tags.includes("blossom-out-of-stock") || product_tags.includes("out-of-stock") ){
       $('.button-cart-jtpl').text("Out Of Stock");   
       $(".shopify-payment-button").attr("style","display:none !important");
     }else{
       $('.button-cart-jtpl').text("Sold Out");   
  
     }
     if($(".pre-text-jtpl .pn_note-jtpl").length > 0){
       $(".pn_note-jtpl").remove();
     }
     if($(".pre-text-jtpl .preorder-description").length > 0){
      $(".preorder-description").remove();
     }
       $(".shopify-payment-button").attr("style","display:none !important");
  } else {
    $('.button-cart-jtpl').text("Add to Cart");
      if($(".pre-text-jtpl .pn_note-jtpl").length > 0){
       $(".pn_note-jtpl").remove();
 
     }
    if($(".pre-text-jtpl .preorder-description").length > 0){
      $(".preorder-description").remove();
     }
       $(".shopify-payment-button").attr("style","display:block !important");
  }
   handleDates = setInterval(changeDate,500);
});

function changeDate(){
     const nth = function(e) {
  const dString = String(e);
  const last = +dString.slice(-2);
  if (last > 3 && last < 21) return '<sup>th</sup>';
  switch (last % 10) {
    case 1:  return "<sup>st</sup>";
    case 2:  return "<sup>nd</sup>";
    case 3:  return "<sup>rd</sup>";
    default: return "<sup>th</sup>";
  }
}



  if($('.preorder-description').length == 0 || $(".pn_note-jtpl").val()==""){
    $('.preorder-description').attr("style","display: none !important"); 
    return false;
  }
  var d = new Date();
  console.log(d);

  var e=new Date(d);
  e.setDate(d.getDate()+1)
  console.log("hi",e.toDateString());
  
  var date_msg = $('.preorder-description').html();
  
  var split_date_msg = date_msg.split(" ");  
  var today_date = date_msg.match(/\d+/);
  const monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
    "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
  ];
const addWeeksToDate = (dateObj,numberOfWeeks) => {
  dateObj.setDate(dateObj.getDate()+ numberOfWeeks * 7);
  return dateObj;
}
const preodre_value = $("buy-buttons.buy-buttons.buy-buttons--has-dynamic").attr("preorder-date");
  console.log(preodre_value);
   
const numberOfWeeks = preodre_value; 
  // var specificProductDate =  date.getDate();
const get_week = (addWeeksToDate(new Date(), preodre_value));
     console.log(get_week);
  
             var newWeek = get_week;
      // console.log(newWeek);
        // var newDate = new Date(Date.now() + newWeek * 24*60*60*1000);
        // console.log(newDate);
        var currmonth = newWeek.getMonth(); 
        var year = newWeek.getFullYear();

       var dayVal =  padTo2Digits(newWeek.getDate());
       var dayValue = dayVal+""+nth(dayVal);
      console.log(dayValue);
      var dateVal = dayValue+" "+monthNames[currmonth];
       var plus_date = date_msg.split("ON");  
       var message = plus_date[0]+" ON " +dateVal;
       // var message = newWeek;
     
       $('.preorder-description').html(message);     
      $('.preorder-description').attr("style","display: block");
       clearInterval(handleDates);
 //                var actualDate = new Date(); // convert to actual date
 //                  var date=new Date();
	// 				var currDate = date.getDate()+" "+monthNames[date.getMonth()]+" "+date.getFullYear();
 //               console.log("Current:"+currDate);
 //   console.log("Current:"+date.getMonth());
 //          var future = monthNames[date.getMonth()-0 , 2];
 //           // var futureDate = date.getDate()+" "+future;
 //         var nVal = nth(date.getDate());
 //         var futureDate = date.getDate()+""+nVal+" "+future;
 //          console.log("Future:"+futureDate);
 //         // Add five days to current date
 //       var specificProductDate =  date.getDate() + 2;
 //       var nVal = nth(date.getDate());
 //        var specificProductDateFull = date.getDate() + 2 +""+nVal+" "+monthNames[date.getMonth()];
  
 //    //  var collection = $(".custom_collections").val();
  
 //  // if(collection == 'true'){
 //  //     var plus_date = date_msg.split("ON");  
 //  //   var message = plus_date[0]+" ON 6TH FEBRUARY";
 //  //    $('.preorder-description').text(message);
 //  //    $('.preorder-description').attr("style","display: block !important");
 //  // }else{

 // if ($("body").hasClass("preorder-new-jtpl")){
 //    $('.preorder-description').html("THIS ITEM WILL BE SHIPPED ON "+ specificProductDateFull);     
 //      $('.preorder-description').attr("style","display: block !important");
 //   clearInterval(handleDates);
 // }
  // else{
  //   // if(future == 'FEBRUARY'){
  //    // console.log("Hello fab")
  //      $('.preorder-description').html("THIS ITEM WILL BE SHIPPED ON 29<sup>th</sup> FEBRUARY");
  //      $('.preorder-description').attr("style","display: block !important");
  //      clearInterval(handleDates);
  //   // }else{
  //            $('.preorder-description').html("THIS ITEM WILL BE SHIPPED ON "+ futureDate);     
  //     $('.preorder-description').attr("style","display: block !important");
  //      clearInterval(handleDates);
  //   // }
  // }

    // if(e.getDay() == 1){
    //     var days = 32;
    //     var newDate = new Date(Date.now() + days * 24*60*60*1000);
    //     var currmonth = newDate.getMonth(); 
    //     var year = newDate.getFullYear();

    //    var dayVal =  padTo2Digits(newDate.getDate());
    //    var dayValue = dayVal+""+nth(dayVal);
    //   console.log(dayValue);
    //   var dateVal = dayValue+" "+monthNames[currmonth].toUpperCase();
    //    var plus_date = date_msg.split("ON");  
    //    var message = plus_date[0]+" ON " +dateVal;
      
    //    $('.preorder-description').html(message);     
    //   $('.preorder-description').attr("style","display: block !important");
    // }else {
    //     var days1 = 33 - e.getDay();
    //     var newDate1 = new Date(Date.now() + days1 * 24*60*60*1000);
    //     var currmonth1 = newDate1.getMonth(); 
    //     var year1 = newDate1.getFullYear();
    //     var plus_date1 = date_msg.replace(today_date, `${newDate1.getDate()}`.padStart(2, "0")).replace(split_date_msg[split_date_msg.length - 1], monthNames[currmonth1].toUpperCase());

    //   var dayVal1 =  padTo2Digits(newDate1.getDate());
    //   var dayValue1 = dayVal1+""+nth(dayVal1);
    //   var dateVal1 = dayValue1+" "+monthNames[currmonth1].toUpperCase();
    //    var plus_date = date_msg.split("ON");  
    //    var message = plus_date[0]+" ON " +dateVal1;      
    //    $('.preorder-description').html(message);
    //   $('.preorder-description').attr("style","display: block !important");
    // }
}
 function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}
$( document ).ready(function() {
     if($("body").hasClass("collection-flash-deals")){
       var url = window.location.href;
       if(url.indexOf("?sel=")>-1){
         var url_new = url.split("?sel=");
         
           $("carousel-navigation button").each(function(){
             var text = $(this).text().trim();
             var text_new = text.toLowerCase();
             text_new = text_new.replaceAll(" ","-");
             console.log(text_new+"===="+$.trim(url_new[1]));
             if(text_new == $.trim(url_new[1])){
               $(this).trigger("click");
               return false;
             }
           })
       }
    }
   
$("body").on("click",".product-card .color-swatch" ,function(e){
  var $this = $(this);  
  var id = $(this).attr("for");
 var color =  $("#"+id).val();
  console.log(color);
  showInStockStatusOnCard($(this),color)
  
var SizeHTML = '';
var allSizes='';

   $this.parents(".product-card").find(".collection-size-filter-ul").html('');
  $this.parents(".product-card").find(".collection-page-nojs-selct-box option").each(function(){
    var $this2 = $(this);
     var name = $this2.attr("data-name");
    var available = $this2.attr("data-available");
    var href = $this2.attr("data-href");
    var variant_id = $this2.attr("value");
    if(name.indexOf(color) > -1 && available == 'true'){
      // console.log(name+"===="+color+"=="+variant_id)
   var value = name.replace(color,"");
       value = value.replace(" / ","");
      var hrefArr = href.split("=");
      var href_new = hrefArr[0]+"="+variant_id;
      //console.log(href_new);
      SizeHTML += '<li><a href="'+href_new+'&no_rule=true"><div data-name="'+color+'" class="size-variant-collection page" data-var_id="'+variant_id+'">'+value+'</div></a><span class="size-variant--highphan">-</span> </li>';
    }          
    //For all sizes
      if(name.indexOf(color) > -1){
   var value = name.replace(color,"");
       value = value.replace(" / ","");
      var hrefArr = href.split("=");
      var href_new = hrefArr[0]+"="+variant_id;
      //console.log(href_new);
      allSizes += '<li><a href="'+href_new+'&no_rule=true"><div data-name="'+color+'" class="size-variant-collection page" data-var_id="'+variant_id+'">'+value+'</div></a><span class="size-variant--highphan">-</span> </li>';
    }                                                
  });
  
   if(SizeHTML == '' && $this.parents(".product-card__info").hasClass("accessories-product")){
  // SizeHTML += "<li>Out Of Stock</li>";
  SizeHTML += "";
 }

    if(SizeHTML == ''){       
        // SizeHTML+= "<li>Out of Stock</li>";
        if ($(this).parents('product-card').find("sold-out-badge").length) {
          $(this).parents('product-card').find("sold-out-badge").show();
          $(this).parents('product-card').find("on-sale-badge").hide();
          //console.log("All-sizes---->",allSizes);
          //SizeHTML += allSizes; 
        }
        else{
          if ($(this).parents("product-card").hasClass("out-of-stock")) {


            if (! $(this).parents("product-card").find('badge-list').length) {
                $(this).parents("product-card").find('.product-card__figure').append("<badge-list class='badge-list badge-list--vertical' ></badge-list>");
                console.log("Append badge-list-=-==");
            }
          $(this).parents("product-card").find('badge-list').append('<sold-out-badge class="badge badge--sold-out-jtpl">Out of stock</sold-out-badge>')  
          }
          else{
            $(this).parents("product-card").find('badge-list').append('<sold-out-badge class="badge badge--sold-out-jtpl">Sold Out</sold-out-badge>')
          }

          $(this).parents('product-card').find("sold-out-badge").show();
          $(this).parents('product-card').find("on-sale-badge").hide();
          //console.log("All-sizes---->",allSizes);
          //SizeHTML += allSizes; 

        }

    }else{

      $(this).parents('product-card').find("sold-out-badge").hide();

       $(this).parents('product-card').find("on-sale-badge").show();

    }
 
   $this.parents(".product-card").find(".collection-size-filter-ul").html('');
  $this.parents(".product-card").find(".collection-size-filter-ul").html(SizeHTML);
 $this.parents(".product-card").find(".collection-size-filter-ul li:last-child .size-variant--highphan").remove();
 
});

//Show In stock status on card starts//
function showInStockStatusOnCard(swatch,color) {

  let availableVariant;
  let inventory_status;
 //console.log("swatch fn.---",swatch);
 //console.log("color fn.----",color);
  let res=swatch.parents(".product-card").find(".collection-page-nojs-selct-box option").each(function(key,item){
    var name = $(item).attr("data-name");
    var available = $(item).attr("data-available");
    //console.log("name----",name);
    //console.log("available -----",available);
  
    if (name.indexOf(color) > -1 && available == 'true' ) {
      availableVariant=$(item);
      return false;
    }
    
  });
  console.log("availableVariant---->",availableVariant);
  if ($(availableVariant).length) {
    let low_threshold = '3';
    let middle_threshold = '15';
    low_threshold=parseInt(low_threshold)
    middle_threshold=parseInt(middle_threshold)
    let low_stock_msg="● " +'Only count  <invquantity> left in stock – order soon</invquantity>'
    let middle_stock_msg = "● " + 'Low stock – order soon';
    let in_stock_msg = "● " + 'In Stock';   
    let inventory=$(availableVariant).attr('data-inventory');
    inventory=parseInt(inventory);
    let inventory_policy=$(availableVariant).attr('data-inventory-policy')
    if (inventory>0 && inventory<=low_threshold) {
      console.log("low_stock_msg---==",low_stock_msg);
      inventory=`${inventory}` ;
      swatch.parents(".product-card").find(".inv-msg-jtpl span").html(low_stock_msg.replace("count",inventory));
      inventory_status="text-error"
      // swatch.parents(".product-card").find(".inv-msg-jtpl").text(low_stock_msg.replace('', inventory))
    }
    else if(inventory>low_threshold && inventory <= middle_threshold){
       swatch.parents(".product-card").find(".inv-msg-jtpl span").html(middle_stock_msg)
       inventory_status="text-warning"
    }
    else if(inventory > middle_threshold){
       swatch.parents(".product-card").find(".inv-msg-jtpl span").html(in_stock_msg)
       inventory_status="text-success"
    }
    else{
       swatch.parents(".product-card").find(".inv-msg-jtpl span").html("")
    }
    console.log("Inventory to show === ",inventory);
     console.log("Inventory policy to show === ",inventory_policy);
  }
  else{
    
    let out_of_stock=swatch.parents(".product-card").hasClass('out-of-stock')
    if (out_of_stock) {
      swatch.parents(".product-card").find(".inv-msg-jtpl span").text("")
    }
    else{
      swatch.parents(".product-card").find(".inv-msg-jtpl span").text("")
    }
  inventory_status="text-error"
  
}
swatch.parents(".product-card").find(".inv-msg-jtpl").removeAttr("class")
  swatch.parents(".product-card").find("variant-inventory").addClass(`inv-msg-jtpl inventory ${inventory_status} justify-items-center h5`)
  // console.log("Res---->",res);
  
  
}
//Show In stock status on card ends//

  
  

    $('#jot-form').show();
  $( ".custom-close-button-jtpl" ).click(function() {
  $( ".modal-dialog" ).css("display", "none");
});
  $('body').on('click','.custom-close-button-jtpl',function () {
   $('body') .removeClass('page-waiver-form');
});
  $(".waiver-form-button-jtpl").click(function() {
  $(".modal-dialog").fadeIn(300);
});
    $(".waiver-form-button-jtpl").click(function() {
  $('body') .addClass('page-waiver-form');
});
$('.main-waiver-form-jtpl').on('click', function(){
  $('.inner-waiver-form-jtpl .list-unstyled').toggleClass('active'); 
});
 


  
  
$(".product details .accordion__content").each(function(){
    var acc_content = $(this).text().length;
  // alert(acc_content)
  if(acc_content == 3903 ){
    $(this).parent("details").hide();
  }
});
  

$('.tab-content:first').show();
$('li.tab-link').click(function () {
    $('li.tab-link').removeClass('current');
   $(this) .addClass('current');
  var getAttr =  $(this).attr('data-tab');
    console.log(getAttr);
    $('.tab-content').each(function () {
   //   $('.tab-content').hide();
       var getContentAttr = $(this) .attr('id');
        if(getContentAttr == getAttr){
$(this).show();
        }else{
            $(this).hide();
        }
    });
});
 
 





$('body').on('click','span.showMoreLess.moreline',function(){
$(this).hide();
    $('.prose.custom_prse_coll').show();
    $('.prose.custom_show_more').hide();
  $('span.showMoreLess.lessline').show();
            });

$('body').on('click','span.showMoreLess.lessline',function(){
$(this).hide();
    $('.prose.custom_prse_coll').hide();
    $('.prose.custom_show_more').show();
  $('span.showMoreLess.moreline').show();
            });


setTimeout(function(){
  $(".collection-size-filter-ul li:last-child .size-variant--highphan").remove();
},2000);





               
// remove item from drawer start
$(document).on('click',".CartItem-add-on .QuantitySelector__Button",function(e){
   e.preventDefault();    
  var $this = $(this);
    var qty = parseInt($this.attr("data-quantity"));
   
    var product_title = $.trim($(this).parents(".CartItem__QuantitySelector").find(".remove-item-title").text());
      var item_id_main = $(this).parents(".QuantitySelector").find("input").attr('data-id');
      var item_id_main_line = $(this).parents(".QuantitySelector").find("input").attr('data-line');
      var href = $(this).attr('href');
      var item_match = false;
       $(".CartItem__Property").each(function(){
        var prop = $.trim($(this).find(".hidden-input-properties").text());
         //console.log(prop+"==="+product_title);
        if(prop.indexOf(product_title) != -1){
          var item_id = $(this).data('line');
          var cup_qty = parseInt(qty) * 2;
          $.ajax({
            'url':'/cart/change.js',
            'data':{
              'quantity':cup_qty,
              'line':item_id
            },
            dataType:'json',
            success:function(rr){
                 $.ajax({
                  'url':'/cart/change.js',
                  'data':{
                    'quantity':qty,
                    'id':item_id_main
                  },
                  dataType:'json',
                  success:function(){
                    if($("body").hasClass("template-cart")){
                           window.location.reload();
                       }else{
                         updateCartDrwaer();
                       }
                  }
                });
            }
          });
          item_match = true;
          return false;
        }
      });
});

$("body").on('click', '.CartItem-add-on .link.text-xs', function(event){  
      event.preventDefault();
      var product_title = $.trim($(this).find(".remove-item-title").text());
      var item_id_main = $(this).attr('data-id');
      var item_id_main_line = $(this).attr('data-line');
      var href = $(this).attr('href');
      var item_match = false;
       $(".CartItem__Property").each(function(){
        var prop = $.trim($(this).find(".hidden-input-properties").text());
         console.log(prop+"==="+product_title);
        if(prop.indexOf(product_title) != -1){
          console.log(item_id_main)
          
          var item_id = $(this).attr('data-id');
          console.log(item_id)
          $.ajax({
            'url':'/cart/change.js',
            'data':{
              'quantity':0,
              'id':item_id
            },
            dataType:'json',
            success:function(rr){
                 $.ajax({
                  'url':'/cart/change.js',
                  'data':{
                    'quantity':0,
                    'id':item_id_main
                  },
                  dataType:'json',
                  success:function(){
                    if($("body").hasClass("template-cart")){
                           window.location.reload();
                       }else{
                         updateCartDrwaer();
                       }
                  }
                });
            }
          });
          item_match = true;
          return false;
        }
      });
  
      if(item_match == false){
        $.ajax({
          'url':'/cart/change.js',
          'data':{
            'quantity':0,
            'id':item_id_main
          },
          dataType:'json',
          success:function(){
              // alert($("body").hasClass("template-cart"));
            if($("body").hasClass("template-cart")){
                   window.location.reload();
               }else{
              updateCartDrwaer();
               }
          }
        });
      }
    });
 

}); //documentready end block




// Update Card Drawer
    
function updateCartDrwaer(){ 

     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true  //this code is for prestige theme, is to refresh the cart
   }));
  return false;
     
}
/***************Custom Add to cart******************/
/*** yes button click function ****/
  $(document).on('click','.yes_retail_btn',function(e){
    e.preventDefault();
    var $this = $(this);
   var inventory_qty = $.trim($('.inventory_qty',this).attr('data-inventorytoAdd'));
   var selected_product =$(this).parents('.inventory_alert_popup').attr('data-variant');
   
    if($(this).parents(".inventory_alert_popup").hasClass("cart-drawer")){
      //do nothing
       $('.CartItem__QuantitySelector .custom__plus.QuantitySelector__CurrentQuantity[data-id="'+selected_product+'"]').val(inventory_qty);   
    }else{
       $('.product-info__block-item .quantity-selector .quantity-selector__input').val(inventory_qty);   
    }
     $(this).parents('.inventory_alert_popup').removeClass('active');
  
    // $('.all_product_get[data-var-id="'+selected_product+'"]')[0].click();
    // if(window.location.href.indexOf('cart') > -1){
    //   $('form[action="/cart"]').submit();
    // }else{
       if($this.parents(".inventory_alert_popup").hasClass("cart-drawer")){
      //do nothing
         addProductRetailCart(selected_product,inventory_qty);
  
    }else{
        var main_text1 = $('buy-buttons.buy-buttons button.button');
        var text = $('buy-buttons.buy-buttons button.button').text();
        // main_text1.text("Adding in Cart...");
          addProductRetail(selected_product,inventory_qty,main_text1,text);
       }
     
   // }
    
     return false;
});
  /*** yes button click function end here ***/
  /*** no button click function ****/
 $(document).on('click','.no_retail_btn',function(e){
    e.preventDefault();
    var selected_product =$(this).parents('.inventory_alert_popup').attr('data-variant');
    if($(this).parents(".inventory_alert_popup").hasClass("cart-drawer")){
       $('.CartItem__QuantitySelector .QuantitySelector__CurrentQuantity').removeClass('input--error');
    }else{
      $('.ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity').removeClass('input--error');
    }
    
   $(this).parents('.inventory_alert_popup').removeClass('active');

   if($(this).parents(".inventory_alert_popup").hasClass("cart-drawer")){
     var newQTY = $(this).parents(".inventory_alert_popup").attr("data-old-qty");
     //alert(newQTY+"==="+selected_product);
      $('input.QuantitySelector__CurrentQuantity[data-id="'+selected_product+'"]').val(newQTY); 
      addProductRetailCart(selected_product,newQTY);
  
   }
    // if(window.location.href.indexOf('cart') > -1){
    //    var newQTY =parseInt($.trim($('.custom__plus.QuantitySelector__CurrentQuantity[data-id="'+selected_product+'"]').attr('data-qty')));  
    //      $('.custom__plus.QuantitySelector__CurrentQuantity[data-id="'+selected_product+'"]').val(newQTY);       
    // }
   return false;
});

 function addProductRetailCart(main_pro_id,qty_val){
    jQuery.ajax({  
      type: 'POST',
      url: '/cart/change.js',
      data:{
        id: main_pro_id,
        quantity: qty_val
      },
      dataType: 'json',
      success: function(productid){       
         // window.location.href='/cart';
          jQuery.getJSON('/cart.js', function(cart) {
             document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
                bubbles: true , 
                detail: {
                variant: main_pro_id,
                quantity: qty_val
                }
                }));
            $('a[aria-controls="cart-drawer"]').get(0).click();
             // $(".Header__CartCount").html(cart.item_count);
           
          });
         return false;
     },
      error:function(error){
         var error_msg = error.responseJSON.description;
              var stock= 0;
        
           var stock = $(".CartItem__QuantitySelector .QuantitySelector__CurrentQuantity[data-id="+main_pro_id+"]").attr("data-inv-qty");
            console.log(stock);
         
            if(error_msg.indexOf("You can't add more") != -1){
              error_msg  = "We currently have "+stock+" item(s) in the stock. Please reduce the quantity." ;
            }
        // main_text1.text('');
         // main_text1.text(text);
        //alert(error.responseJSON.description);
        $('.inventory_error').addClass('active');
        $('.inventory_error h3').text(error_msg);
        main_text1.parents('.quantity__variant').find('.quantity__input').addClass('input--error');
        //main_text1.parents('td').append('<p class="cart_error error">'+error.responseJSON.description+'</p>');
          // setTimeout(function(){$('.cart_error').remove();},5000)
     }
    }); 
   addonScriptt();
   updateCartDrwaer();
  }


 function addProductRetail(main_pro_id,qty_val,main_text1,text){
    jQuery.ajax({  
      type: 'POST',
      url: '/cart/add.js',
      data:{
        id: main_pro_id,
        quantity: qty_val
      },
      dataType: 'json',
      success: function(productid){
        if($(".inventory_alert_popup.active").hasClass("cart-drawer")){
          //do nothing
        }else{
            console.log(main_text1);
             // main_text1.text("Added To Cart");
         setTimeout(function() {  
           // main_text1.text('');
           // main_text1.text(text);
            }, 2500);
        }
       
         // window.location.href='/cart';
          jQuery.getJSON('/cart.js', function(cart) {
             document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
                bubbles: true , 
                detail: {
                variant: main_pro_id,
                quantity: qty_val
                }
                }));
            $('a[aria-controls="cart-drawer"]').get(0).click();
               $("buy-buttons.buy-buttons button.button").removeAttr("disabled");
               $("buy-buttons.buy-buttons button.button").removeAttr("aria-busy");
             // $(".Header__CartCount").html(cart.item_count);
            updateCartDrwaer();
          });
         addonScriptt();
         return false;
     },
      error:function(error){
         var error_msg = error.responseJSON.description;
              var stock= 0;
          if($(".inventory_alert_popup.active").hasClass("cart-drawer")){
    
           var stock = $(".CartItem__QuantitySelector .QuantitySelector__CurrentQuantity[data-id="+main_pro_id+"]").attr("data-inv-qty");
            console.log(stock);
          }else{
        
            $(".for_variant_avail_or_no option").each(function(){
              var inventory = $(this).attr("data-vv-id");
             console.log(main_pro_id+"==="+inventory);
              if(main_pro_id==inventory){
                stock = parseInt($(this).attr("data-inv-qty"));
              }
            });
            }
            console.log(stock);
            if(error_msg.indexOf("You can't add more") != -1){
              error_msg  = "We currently have "+stock+" item(s) in the stock. Please reduce the quantity." ;
            }
         // main_text1.text(text);
        //alert(error.responseJSON.description);
        $('.inventory_error').addClass('active');
        $('.inventory_error h3').text(error_msg);
        main_text1.parents('.quantity__variant').find('.quantity__input').addClass('input--error');
        //main_text1.parents('td').append('<p class="cart_error error">'+error.responseJSON.description+'</p>');
          // setTimeout(function(){$('.cart_error').remove();},5000)
     }
    }); 
  }


$(document).on('click','.quantity-selector .quantity-selector__input .quantity-selector__button .icon-plus',function(e){
  e.preventDefault();
//$(this).parents('.QuantitySelector').find('.QuantitySelector__CurrentQuantity').val($(this).attr('data-quantity'));
var qty_val = $(this).attr('data-quantity');
  //$(this).parents('.QuantitySelector').find('.QuantitySelector__CurrentQuantity').val();
var max_qty = $(this).parents('.QuantitySelector').find('.QuantitySelector__CurrentQuantity').attr('data-max'); 
var check_preOrder = $(this).parents('.QuantitySelector').find('.QuantitySelector__CurrentQuantity').attr('data-preorder'); 
var main_pro_id = $(this).parents('.QuantitySelector').find('.QuantitySelector__CurrentQuantity').attr('data-id'); 
  var checkInventory= inventoryCheck(qty_val,max_qty,check_preOrder,main_pro_id,'cart');  
  console.log("Cart..."+checkInventory+"=="+qty_val+"=="+max_qty+"=="+check_preOrder+"=="+main_pro_id+"=="+'cart');
       if(checkInventory == false){
          return false;
        }

  console.log($(this).attr('data-urlVal'));
   if($("body").hasClass("template-cart")){
window.location.href= $(this).attr('data-urlVal');
   }else{
      $.ajax({
          'url':'/cart/change.js',
          'data':{
            'quantity':qty_val,
            'id':main_pro_id
          },
          dataType:'json',
          success:function(response){
             console.log(response);
              updateCartDrwaer();
               
          },
        error:function(error){
             console.log(error);
               
          }
        });
   }
});

/*** inventory check on cart page END HERE***/
/*** Inventory check on key up ***/

  $(document).on('change',".CartItem__QuantitySelector input.QuantitySelector__CurrentQuantity",function(e){
   e.preventDefault();
    
  var $this = $(this);
    
  var qty_val = $(this).val();
  var max_qty = $(this).attr('data-max'); 
  var check_preOrder = $(this).attr('data-preorder'); 
  var main_pro_id = $(this).attr('data-id'); 
  var checkInventory= inventoryCheck(qty_val,max_qty,check_preOrder,main_pro_id,'cart');

    if(checkInventory == false){
          return false;
        }
    
   if($(this).closest(".CartItem").hasClass("CartItem-add-on")){
      CartupdateonAddon($this);
      return false;
    }
    
     if($("body").hasClass("template-cart")){
if($this.attr('data-href') == undefined){
    var id =   $this.attr('data-line-id');
    var url =  "/cart/change?quantity="+qty_val+"&id="+id;
      window.location.href= url;
    }else{
      window.location.href= $this.attr('data-href');
    }
   }else{
       var id =   $this.attr('data-line-id');
      $.ajax({
          'url':'/cart/change.js',
          'data':{
            'quantity':qty_val,
            'id':id
          },
          dataType:'json',
          success:function(){             
              updateCartDrwaer();               
          }
        });
   }
    return false;
  });



$('.tab-content:first').show();
$('li.tab-link').click(function () {
    $('li.tab-link').removeClass('current');
   $(this) .addClass('current');
  var getAttr =  $(this).attr('data-tab');
    console.log(getAttr);
    $('.tab-content').each(function () {
   //   $('.tab-content').hide();
       var getContentAttr = $(this) .attr('id');
        if(getContentAttr == getAttr){
$(this).show();
        }else{
            $(this).hide();
        }
    });
});




$('body').on('click','span.showMoreLess.moreline',function(){
$(this).hide();
    $('.prose.custom_prse_coll').show();
    $('.prose.custom_show_more').hide();
  $('span.showMoreLess.lessline').show();
            });

$('body').on('click','span.showMoreLess.lessline',function(){
$(this).hide();
    $('.prose.custom_prse_coll').hide();
    $('.prose.custom_show_more').show();
  $('span.showMoreLess.moreline').show();
            });


  $(document).ready(function(){
$('.read_more_less').on('click', function(e){
  e.preventDefault();
  console.log("1")
  if($('.product-description-full').is(':visible')) {
    console.log("2")
    $('.product-description-full').stop(true, true).fadeOut(function(){ 
      $('.product-description-short').stop(true, true).fadeIn();
    });
  } else {
    console.log("3")
    $('.product-description-short').stop(true, true).fadeOut(function(){ 
      $('.product-description-full').stop(true, true).fadeIn();
    });
  }
});

   if($('scroll-carousel.complementary-products__product-list div.horizontal-product-card').length == 0){
    $(".product-info__block-list .product-info__block-item[data-block-type=complementary-products]").hide();
      }
    $('.klaviyo-form button').removeClass('kl-private-reset-css-Xuajs1');
$('.klaviyo-form button').addClass('cstm-button-kalviyo');
  });
 



// Addon js start
  
// remove item from drawer start
$(document).on('click',".CartItem-add-on .QuantitySelector__Button",function(e){
   e.preventDefault();    
  var $this = $(this);
    var qty = parseInt($this.attr("data-quantity"));
   
    var product_title = $.trim($(this).parents(".CartItem__QuantitySelector").find(".remove-item-title").text());
      var item_id_main = $(this).parents(".QuantitySelector").find("input").attr('data-id');
      var item_id_main_line = $(this).parents(".QuantitySelector").find("input").attr('data-line');
      var href = $(this).attr('href');
      var item_match = false;
       $(".CartItem__Property").each(function(){
        var prop = $.trim($(this).find(".hidden-input-properties").text());
         //console.log(prop+"==="+product_title);
        if(prop.indexOf(product_title) != -1){
          var item_id = $(this).data('line');
          var cup_qty = parseInt(qty) * 2;
          $.ajax({
            'url':'/cart/change.js',
            'data':{
              'quantity':cup_qty,
              'line':item_id
            },
            dataType:'json',
            success:function(rr){
                 $.ajax({
                  'url':'/cart/change.js',
                  'data':{
                    'quantity':qty,
                    'id':item_id_main
                  },
                  dataType:'json',
                  success:function(){
                    if($("body").hasClass("template-cart")){
                           window.location.reload();
                       }else{
                         updateCartDrwaer();
                       }
                  }
                });
            }
          });
          item_match = true;
          return false;
        }
      });
});

$("body").on('click', '.CartItem-add-on .CartItem__Remove', function(event){  
      event.preventDefault();    
      var product_title = $.trim($(this).find(".remove-item-title").text());
      var item_id_main = $(this).attr('data-id');
      var item_id_main_line = $(this).attr('data-line');
      var href = $(this).attr('href');
      var item_match = false;
       $(".CartItem__Property").each(function(){
        var prop = $.trim($(this).find(".hidden-input-properties").text());
         console.log(prop+"==="+product_title);
        if(prop.indexOf(product_title) != -1){
          var item_id = $(this).data('line');
          $.ajax({
            'url':'/cart/change.js',
            'data':{
              'quantity':0,
              'line':item_id
            },
            dataType:'json',
            success:function(rr){
                 $.ajax({
                  'url':'/cart/change.js',
                  'data':{
                    'quantity':0,
                    'id':item_id_main
                  },
                  dataType:'json',
                  success:function(){
                    if($("body").hasClass("template-cart")){
                           window.location.reload();
                       }else{
                         updateCartDrwaer();
                       }
                  }
                });
            }
          });
          item_match = true;
          return false;
        }
      });
  
      if(item_match == false){
        $.ajax({
          'url':'/cart/change.js',
          'data':{
            'quantity':0,
            'id':item_id_main
          },
          dataType:'json',
          success:function(){
              // alert($("body").hasClass("template-cart"));
            if($("body").hasClass("template-cart")){
                   window.location.reload();
               }else{
              updateCartDrwaer();
               }
          }
        });
      }
    });

// remove item from drawer end  

// Addon js end

// 3D cart drawer js start 18 July 2024 

// window.addEventListener("Angle3DAddToCart", function(event) {
//   //$('#cart-drawer').toggle();
//   // $('#cart-drawer').attr('active','');
//  //$('#cart-drawer').toggleAttr('open');
//             var getValues = ('Angle3DAddToCart' + 
//             JSON.stringify(event.detail));
//             console.log('getValues'+getValues);
//         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//       bubbles: true,
//    }));
//   document.querySelector("[aria-controls='cart-drawer']").click();
//   return false;
   
// });
 
// window.addEventListener("Angle3DCustomizerLoaded", function(event) {
//             $('div#tda-customizer-customization-option-value-container-ufhqiq-4fhome input[type="text"],div#tda-customizer-customization-option-value-container-99ss4q-l21aqo input[type="text"], div#tda-customizer-customization-option-value-container-mow9gf-rdumnk input[type="text"], div#tda-customizer-customization-option-value-d1b2oa input[type="text"], div#tda-customizer-customization-option-value-sz6opv input[type="text"], div#tda-customizer-customization-option-value-container-0sxm96-b7gwz input[type="text"], div#tda-customizer-customization-option-value-container-rjsag-754asm input[type="text"], div#tda-customizer-customization-option-value-container-phzdbe-0jglxd input[type="text"]').keyup(function() { 
//                 this.value = this.value.toLocaleUpperCase(); 
//             }); 
  
// });
// // 3D cart drawer js end 18 July 2024 
//   document.addEventListener('DOMContentLoaded', function() {
   
//    window.addEventListener('load', function() {
     
// // var priceElement = $('#tda-customizer-footer-51599404499309 .tda-customizer-footer-left .tda-customizer-variant-price-container')
// //     .find('#tda-customizer-variant-price-51599404499309');
// //     console.log("priceElement: ", priceElement);  
// //     var currentPrice = priceElement.text();  
// //     console.log("currentPrice: ", currentPrice);
// //     var updatedPrice = currentPrice.replace('US', '');
// //     console.log("updatedPrice: ", updatedPrice);
// //     priceElement.text(updatedPrice);  



//     $(".tda-customizer-footer-right").prepend(`<div class="tda-customizer-tax-included production-title-jtpl new-production-time-jtpl">
//             Production takes approximately 4 to 5 weeks, and the item will be dispatched directly from Thailand.<br>
//             Wholesale discounts are available for gyms and clubs.<br>
//           </div>`);
     
// var imageUrls = {
//                 "v35t5": "https://cdn.shopify.com/s/files/1/0253/7245/9094/files/Original_gloves-31july-gold1.png?v=1724302180", 
//                 "nbimgi": "https://cdn.shopify.com/s/files/1/0253/7245/9094/files/Original_gloves-31july-silver1.png?v=1724241766" 
//             };

//             $('body').on('change','#tda-customizer-customization-option-dropdown-ztdxxk', function() {
//                 var selectedValue = $(this).val(); 
//                 var newSrc = imageUrls[selectedValue] || '#'; 
//                 $('#tda-file-upload-image-ztdxxk').attr('src', newSrc);
//             });
//    });
//  });





  document.querySelectorAll('.product-info__block-item[data-block-type=description] li').forEach(function(item) {
    if (item.textContent.includes('Limited Edition (once the product is sold out it will not be restocked)')) {
      item.style.display = 'none';
    }
  });


//  $(document).ready(function() {

//   $("body").on("click","#tda-customizer-customization-option-value-xxt0sx,#tda-customizer-customization-option-value-ve3j9,.tda-customizer-customization-options-container button.tda-accordion",function(){
//     //alert("hai");
//       $('#tda-customizer-section-btn-51670382313837-gw6q7p span').eq(0).addClass('yokkao-font-text-jtpl');
//     var checkElement = setInterval(function() {
//         if ($('.tda-customizer-customization-options-container button#tda-customizer-section-btn-51670382313837-gw6q7p').length) {
//             $('.tda-customizer-customization-options-container button#tda-customizer-section-btn-51670382313837-gw6q7p').addClass('tda-accordion-active');
//             $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-51670382313837-gw6q7p').addClass('overflow-visible');
//             $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-51670382313837-gw6q7p').css({
//                 'max-height': 'min-content',
//                 'padding': '20px'
//             });
//             clearInterval(checkElement);
//         }
//     }, 100);
     
//   });
// $(document).click(function(event) {
//     if (!$(event.target).is('#tda-customizer-customization-option-value-xxt0sx,#tda-customizer-customization-option-value-ve3j9')) {
//         $('#tda-customizer-section-btn-51670382313837-gw6q7p span').eq(0).removeClass('yokkao-font-text-jtpl');
//     }
   
// });

// // Use js for custom heavy bag start
//     $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-lz0zyp",function(){
//        $('.tda-customizer-customization-options-container .tda-customizer-section-btn-51944615379309-6dhd0g, span.add-img-with-add-text-jtpl').css('display','none');
//       });
//         $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-j3ci5q",function(){
//        $('.tda-customizer-customization-options-container .tda-customizer-section-btn-51944615379309-6dhd0g, span.add-img-with-add-text-jtpl').css('display','block');
//       });
//       $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-rwr11i",function(){
//        $('.tda-customizer-customization-options-container .tda-customizer-section-btn-51944615379309-towws, span.add-img-with-add-text-jtpl').css('display','none');
//       });
//         $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-y017i6",function(){
//        $('.tda-customizer-customization-options-container .tda-customizer-section-btn-51944615379309-towws, span.add-img-with-add-text-jtpl').css('display','block');
//       });
//   // Use js for custom heavy bag end
   
//     var checkElement = setInterval(function() {
//         if ($('.tda-customizer-customization-options-container button#tda-customizer-section-btn-51670382313837-gw6q7p').length) {
//             $('.tda-customizer-customization-options-container button#tda-customizer-section-btn-51670382313837-gw6q7p').addClass('tda-accordion-active');
//             $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-51670382313837-gw6q7p').addClass('overflow-visible');
//             $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-51670382313837-gw6q7p').css({
//                 'max-height': 'min-content',
//                 'padding': '20px'
//             });
//             clearInterval(checkElement);
//         }
//     }, 100);

//      $("body").on("click","#tda-customizer-section-btn-51670382313837-i1gma, #tda-customizer-section-btn-51670382313837-8o6855, #tda-customizer-section-btn-51670382313837-v6sxn4s",function(){
//   if($("#tda-customizer-customization-option-value-ve3j9").hasClass("tda-customizer-customization-option-value-selected") || $("#tda-customizer-customization-option-value-xxt0sx").hasClass("tda-customizer-customization-option-value-selected")){
//                   setTimeout(function() {
//       $('#tda-customizer-section-btn-51670382313837-gw6q7p span').eq(0).addClass('yokkao-font-text-jtpl');
//                   },400);
//   } else {
   
//       $('#tda-customizer-section-btn-51670382313837-gw6q7p span').eq(0).removeClass('yokkao-font-text-jtpl');
//   }
// });


// // Use js for custom heavy bag start
//     $('.tda-customizer-customization-options-container #tda-customizer-section-panel-51944615379309-towws')
//         .after('<span class="add-img-with-add-text-jtpl">OR</span>');
    
//     // If you want to check periodically, use setInterval
//     var intervalId = setInterval(function() {
//         // Check if the button exists
//         if ($('.tda-customizer-customization-options-container #tda-customizer-section-panel-51944615379309-towws').length) {
//             // Add the span only once
//             if (!$('.add-img-with-add-text-jtpl').length) {
//                 $('.tda-customizer-customization-options-container #tda-customizer-section-panel-51944615379309-towws')
//                     .after('<span class="add-img-with-add-text-jtpl">OR</span>');
//             }
//             // Optionally, clear the interval once done
//             clearInterval(intervalId);
//         }
//     }, 1000);  
//   // Use js for custom heavy bag end
   
// });

function updateMaxFighterNameHeight() {
    // Reset heights first to allow shrink on resize
    $('.fighter-name').css('height', 'auto');

    let maxHeight = 0;

    $('.fighter-name').each(function () {
        const currentHeight = $(this).outerHeight();
        if (currentHeight > maxHeight) {
            maxHeight = currentHeight;
        }
    });

    // Set CSS variable
    document.documentElement.style.setProperty('--fighter-height', maxHeight + 'px');

    // Apply height to all elements
    $('.fighter-name').css('height', maxHeight + 'px');
}

$(document).ready(function () {
    updateMaxFighterNameHeight();
});

// Use debounce to prevent performance issues on rapid resize
let resizeTimer;
$(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        updateMaxFighterNameHeight();
    }, 100); // delay a bit to allow DOM to settle
});

//If one size list available then hide another size list in product card starts
$(document).ready(function (e) {
  if ($(".collection-size-filter-ul.no-size").length) {
    $(".collection-size-filter-ul.no-size").parents(".product-card_sizelist").prev(".product-card_sizelist").hide()
  }
});
//If one size list available then hide another size list in product card ends
